
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
    "commitHash": "01d3579d51bb8d70038a304cd4dbb7c6366a244b",
    "version": "13.0.0"
};
